import { useSidebar, XolaLogoSimple } from "@xola/ui-kit";
import clsx from "clsx";
import dayjs from "dayjs";
import React, { ReactNode } from "react";
import { XolaHalloweenLogo } from "../../icons/XolaHalloweenLogo";
import { XolaThanksgivingLogo } from "../../icons/XolaThanksgivingLogo";
import { XolaXmasLogo } from "../../icons/XolaXmasLogo";

interface SpecialLogosProps {
    start: string;
    end: string;
    logo: ReactNode | string;
    alt?: string;
    force?: boolean;
}

const year = dayjs().format("YYYY");
const specialLogos: SpecialLogosProps[] = [
    {
        start: `${year}-10-28`,
        end: `${year}-11-01`,
        logo: XolaHalloweenLogo,
        force: false,
    },
    {
        // TODO: Thanksgiving is last Thursday of November. So needs to be dynamic
        start: `${year}-11-22`,
        end: `${year}-11-26`,
        logo: XolaThanksgivingLogo,
        force: false,
    },
    // {
    //     // Disabled because of recent War stuff
    //     start: `${year}-12-06`,
    //     end: `${year}-12-15`,
    //     logo: XolaHanukkahLogo,
    //     force: false,
    // },
    {
        start: `${year}-12-16`,
        end: `${year}-12-18`,
        logo: XolaXmasLogo,
        force: false,
    },
    {
        start: `${year}-12-18`,
        end: `${year}-12-22`,
        alt: "Merry Christmas from Xola",
        logo: "https://files.xola.com/images/logos/xmas-bell-white.png",
        force: false,
    },
    {
        start: `${year}-12-22`,
        end: `${year}-12-25`,
        alt: "Merry Christmas from Xola",
        logo: "https://files.xola.com/images/logos/xmas-candy-white.png",
        force: false,
    },
    {
        start: `${year}-12-25`,
        end: `${year}-12-29`,
        alt: "Merry Christmas from Xola",
        logo: "https://files.xola.com/images/logos/xmas-gift-white.png",
        force: false,
    },
    {
        start: `${year}-12-29`,
        end: `${year}-12-30`,
        alt: "Happy New Year",
        logo: "https://files.xola.com/images/logos/newyear-fireworks-white.png",
        force: false,
    },
    {
        start: `${year}-12-30`,
        end: `${Number(year) + 1}-01-01`, // This logo is till 31st, and on that date year+1 = 2024 (if now is 2023)
        alt: "Happy New Year",
        logo: "https://files.xola.com/images/logos/newyear-confetti-white.png",
        force: false,
    },
    {
        start: `${year}-01-01`,
        end: `${year}-01-05`,
        alt: "Happy New Year",
        logo: "https://files.xola.com/images/logos/newyear-calendar-white.png",
        force: false,
    },
];

export const AppLogo = ({ onClick, className }: { onClick: () => void; className?: string }) => {
    const now = dayjs(); // Change this value to simulate different logos
    const { showText } = useSidebar();

    // These logo SVGs carry an intrinsic 310x101 and overflow the rail unless sized here.
    const sizeClasses = showText ? "h-30 w-30" : "h-12 w-12";

    let Logo = XolaLogoSimple;
    for (const specialLogo of specialLogos) {
        if (specialLogo.force || (now.isSameOrAfter(dayjs(specialLogo.start)) && now.isBefore(specialLogo.end))) {
            if (typeof specialLogo.logo === "string") {
                return (
                    <div className="flex w-full items-center justify-center">
                        <img
                            alt={specialLogo.alt}
                            src={specialLogo.logo}
                            className={clsx(sizeClasses, "object-contain")}
                            onClick={onClick}
                        />
                    </div>
                );
            }

            Logo = specialLogo.logo;
            break;
        }
    }

    return <Logo className={clsx("inline-block", sizeClasses, className)} onClick={onClick} />;
};
